import React, {useEffect, useRef, useState} from 'react';
import {getHistoricalDetailedChart, getHistoricalModalData} from "../api/detailed";
import CustomModal from "../pages/CustomModal";
import * as echarts from "echarts";
import {toast} from "react-toastify";
import FormControl from "@mui/material/FormControl";
import {IconButton, NativeSelect, Tooltip} from "@mui/material";

const HistoricalModal = ({closeModal, id}) => {
    const [data, setData] = useState(null);
    const [batteryColor, setBatteryColor] = useState('');
    const [batteryLabel, setBatteryLabel] = useState('');
    const [fillColor, setFillColor] = useState('');
    const [fillPercentage, setFillPercentage] = useState(null);
    const [header, setHeader] = useState('');
    const [options, setOptions] = useState({
        '3d': "3 Ημερων",
        '7d': "Εβδομάδας",
        '1m': "1 Μήνα",
        '3m': '3 Μηνών'
    });

 function formatAthensDate(dateStr) {
  if (!dateStr) return '-';
  // If already has Z or time zone, don't add. Otherwise, add Z for UTC.
  const safeStr = /[Zz]|[+-]\d{2}:\d{2}$/.test(dateStr) ? dateStr : dateStr + 'Z';
  try {
    return new Date(safeStr).toLocaleString('el-GR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Europe/Athens'
    }).replace(',', '');
  } catch {
    return '-';
  }
}

    const [selectedOption, setSelectedOptions] = useState('3d');
    const chartRef = useRef(null);

    useEffect(() => {
        getHistoricalDetailedChart(id, selectedOption)
            .then((res) => {
                const formattedData = res.data.map(item => {
                    const date = new Date(item.timestamp);
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');

                    return {
                        timestamp: `${day}/${month} ${hours}:${minutes}`,
                        fillLevel: item.fillLevel
                    };
                });

                const dates = formattedData.map(entry => entry.timestamp);
                const values = formattedData.map(entry => entry.fillLevel);

                const historyChart = echarts.init(chartRef.current);
                const emptyOpt = {
                    xAxis: {
                        type: 'category',
                        data: [],
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#eee',
                            },
                        },
                    },
                    yAxis: {
                        type: 'value',
                        min: 0,
                        max: 100,
                        splitNumber: 4,
                        axisLine: {show: true},
                        axisTick: {show: true},
                        axisLabel: {show: true},
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#eee',
                            },
                        },
                    },
                    series: [],
                    grid: {
                        left: '10%',
                        right: '10%',
                        bottom: '15%',
                        top: '15%',
                    },
                    graphic: {
                        elements: [
                            {
                                type: 'text',
                                left: 'center',
                                top: 'middle',
                                style: {
                                    text: 'Δεν υπάρχουν δεδομένα',
                                    fontSize: 18,
                                    fill: '#999',
                                },
                            },
                        ],
                    },
                }

                const options = {
                    xAxis: {
                        type: 'category',
                        data: dates,
                        axisLabel: {
                            interval: 0,
                            fontSize: 12,
                            formatter: (function () {
                                const shownDates = new Set();
                                return function (val) {
                                    const dayStr = val.split(' ')[0];
                                    if (selectedOption === '1m') {
                                        const dayStr = val.split(' ')[0];
                                        const [ddStr, mmStr, yyyyStr] = dayStr.split('/');
                                        const dd = parseInt(ddStr, 10);
                                        const mm = mmStr;
                                        const yyyy = yyyyStr;
                                        const labelDays = [1, 10, 20, 25];

                                        if (labelDays.includes(dd)) {
                                            const labelKey = `${yyyy}-${mm}-${dd}`;
                                            if (!shownDates.has(labelKey)) {
                                                shownDates.add(labelKey);
                                                return `${ddStr.padStart(2, '0')}/${mm}`;
                                            }
                                        }
                                        return '';
                                    }
                                    if (selectedOption === '3m') {
                                        const dayStr = val.split(' ')[0];
                                        const [ddStr, mmStr, yyyyStr] = dayStr.split('/');
                                        const dd = parseInt(ddStr, 10);
                                        const mm = mmStr;
                                        const yyyy = yyyyStr;
                                        const labelDays = [1, 10, 20];

                                        if (labelDays.includes(dd)) {
                                            const labelKey = `${yyyy}-${mm}-${dd}`;
                                            if (!shownDates.has(labelKey)) {
                                                shownDates.add(labelKey);
                                                return `${ddStr.padStart(2, '0')}/${mm}`;
                                            }
                                        }
                                        return '';
                                    }

                                    if (!shownDates.has(dayStr)) {
                                        shownDates.add(dayStr);
                                        return dayStr;
                                    }
                                    return '';
                                };
                            })()
                        }
                    },
                    yAxis: {
                        type: 'value',
                        min: 0,
                        max: 100,
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (params) => {
                            let tooltipText = `${params[0].axisValue}<br/>`;
                            params.forEach(item => {
                                tooltipText += `Πληρότητα: ${item.data}%<br/>`;
                            });
                            return tooltipText;
                        },
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    series: [{
                        data: values,
                        type: 'line',

                        stack: 'Total',
                        smooth: true,
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgb(220,15,15)'
                                },
                                {
                                    offset: 0.4,
                                    color: 'rgb(217,162,16)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgb(55,156,44)'
                                }
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        graphic: {}
                    }],
                }
                historyChart.clear();
                historyChart.resize();
                historyChart.setOption(values.length > 1 ? options : emptyOpt)
            })
            .catch((err) => {
                console.log(err)
                toast.error(err.message)
            })

        getHistoricalModalData(id)
            .then((res) => {
                setData(res.data);
                const batteryHealth = res.data.quickStats.batteryHealth;
                if (batteryHealth < 20) {
                    setBatteryColor('bg-red-100 text-red-800');
                    setBatteryLabel('Πολύ Χαμηλό');
                } else if (batteryHealth < 60) {
                    setBatteryColor('bg-yellow-100 text-yellow-800');
                    setBatteryLabel('Χαμηλό');
                } else {
                    setBatteryColor('bg-green-100 text-green-800');
                    setBatteryLabel('Υψηλό');
                }

                const fillLevel = res.data.quickStats.currentFill;
                setFillPercentage(fillLevel);
                if (fillLevel < 60) {
                    setFillColor('text-green-600');
                } else if (fillLevel < 80) {
                    setFillColor('text-yellow-600');
                } else {
                    setFillColor('text-red-600');
                }

                setHeader(res.data.productDetails.address + ' (' + res.data.productDetails.serial + ') ')
            });
    }, [selectedOption]);

    const handleChange = (event) => {
        setSelectedOptions(event.target.value)
    };
    return (
        <>
            <CustomModal title={header}
                         closeModal={closeModal}>
                <div
                    className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2 p-4 bg-white rounded-xl shadow-lg max-w-5xl mx-auto relative">
                    <div ref={chartRef}
                         style={{width: '100%', height: '100%'}}/>
                    <FormControl style={{
                        width: '100px',
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        color: 'black'
                    }}>
                        <NativeSelect
                            defaultValue={options[0]}
                            onChange={handleChange}
                            inputProps={{
                                name: '',
                                id: 'uncontrolled-native',
                            }}
                        >
                            {Object.entries(options).map(([key, label]) => (
                                <option key={key} value={key}>
                                    {label}
                                </option>
                            ))}
                        </NativeSelect>
                    </FormControl>
                    <div className="p-4 max-w-5xl mx-auto">
                        <h2 className="text-lg font-semibold text-gray-800 mb-4">
                            Τύπος Μονάδας
                            <span className='bg-green-200 m-2 p-2 rounded'>
                                {data?.productDetails?.productType}
                            </span>
                            <Tooltip
                                title={
                                    <div
                                        className="text-[14px] flex flex-col items-center text-center">
                                        <h2 className="text-[14px] mt-2 mb-0">Στοιχεία
                                            Ογκομετρητή</h2>
                                        <hr className="w-full border-gray-300 mb-1 "/>
                         <p className='mb-0'>
  Τελευταία επικοινωνία {formatAthensDate(data?.dates?.last_report_date)}
</p>
<p>
  Τελευταία αποκομιδή {formatAthensDate(data?.dates?.last_collection_date)}
</p>
                                    </div>
                                }>
                                <IconButton>
                                    <div
                                        className="w-4 h-4 bg-blue-600 text-white text-xs flex items-center  justify-center rounded-full cursor-pointer">
                                        i
                                    </div>
                                </IconButton>
                            </Tooltip>

                        </h2>
                        <div
                            className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2">
                            <div className="bg-gray-100 p-4 rounded-2xl shadow-md">
                                <h3 className="text-xl font-semibold mb-2">Επίπεδο Πληρότητας</h3>
                                <div className={`text-3xl font-bold ${fillColor}`}>
                                    {fillPercentage !== null ? `${fillPercentage}%` : '...'}
                                </div>
                            </div>
                            <div className={`${batteryColor} p-4 rounded-2xl shadow-md`}>
                                <h3 className="text-xl font-semibold mb-2">Επίπεδο Μπαταρίας</h3>
                                <div className="flex items-center text-xl font-bold space-x-2">
                                    <span>🔋</span>
                                    <span>{batteryLabel} {data?.quickStats?.batteryHealth}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomModal>
        </>
    );
};

export default HistoricalModal;
